import { Outlet } from 'react-router-dom'

import HelmetSeo from '~/components/helmetSeo'

function SeoConfigLayout() {
  return (
    <>
      <HelmetSeo />
      <Outlet />
    </>
  )
}

export default SeoConfigLayout
